/** True when the member has no project-specific allocation yet (API `allocationType`). */
export function isGlobalAllocationType(allocationType: string): boolean {
  return allocationType.trim().toUpperCase() === "GLOBAL";
}
